// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24ulD","content":"styles_content__2kR33","tableWrap":"styles_tableWrap__33NNZ"};